export const PMOF_URL = 'https://knowledge.hubspot.com/payments/store-a-payment-method-for-future-charges';